<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text-A"><a href="#/Book1/1cover">The Bastard</a></p>
<p class="toc-text"><a href="#/Book1/6chap1#chap1">Book One Fortune’s Whirlwind</a></p>
<p class="toc-text"><a href="#/Book1/7chap2#chap2">Chapter I - The Beating</a></p>
<p class="toc-text"><a href="#/Book1/8chap3#chap3">Chapter II - Behind the Madonna</a></p>
<p class="toc-text"><a href="#/Book1/9chap4#chap4">Chapter III - Blood in the Snow</a></p>
<p class="toc-text"><a href="#/Book1/10chap5#chap5">Chapter IV - Kentland</a></p>
<p class="toc-text"><a href="#/Book1/11chap6#chap6">Chapter V - A Game of Love</a></p>
<p class="toc-text"><a href="#/Book1/12chap7#chap7">Chapter VI - “A Perfect Member of the Mob-ility”</a></p>
<p class="toc-text"><a href="#/Book1/13chap8#chap8">Chapter VII - Brother Against Brother</a></p>
<p class="toc-text"><a href="#/Book1/14chap9#chap9">Chapter VIII - Trap</a></p>
<p class="toc-text"><a href="#/Book1/15chap10#chap10">Chapter IX - Flight</a></p>
<p class="toc-text"><a href="#/Book1/16chap11#chap11">Book Two The House of Sholto and Sons</a></p>
<p class="toc-text"><a href="#/Book1/17chap12#chap12">Chapter I - Swords at St Paul’s</a></p>
<p class="toc-text"><a href="#/Book1/18chap13#chap13">Chapter II - The Black Miracle</a></p>
<p class="toc-text"><a href="#/Book1/19chap14#chap14">Chapter III - Mr. Burke and Dr. Franklin</a></p>
<p class="toc-text"><a href="#/Book1/20chap15#chap15">Chapter IV - The Wizard of Craven Street</a></p>
<p class="toc-text"><a href="#/Book1/21chap16#chap16">Chapter V - The One-Eyed Man</a></p>
<p class="toc-text"><a href="#/Book1/22chap17#chap17">Chapter VI - The Bristol Coach</a></p>
<p class="toc-text"><a href="#/Book1/23chap18#chap18">Chapter VII - To an Unknown Shore</a></p>
<p class="toc-text"><a href="#/Book1/24chap19#chap19">Book Three Liberty Tree</a></p>
<p class="toc-text"><a href="#/Book1/25chap20#chap20">Chapter I - The Secret Room</a></p>
<p class="toc-text"><a href="#/Book1/26chap21#chap21">Chapter II - Mistress Anne</a></p>
<p class="toc-text"><a href="#/Book1/27chap22#chap22">Chapter III - September Fire</a></p>
<p class="toc-text"><a href="#/Book1/28chap23#chap23">Chapter IV - Night of the Axe</a></p>
<p class="toc-text"><a href="#/Book1/29chap24#chap24">Chapter V - Decision</a></p>
<p class="toc-text"><a href="#/Book1/30chap25#chap25">Chapter VI - The Sergeant</a></p>
<p class="toc-text"><a href="#/Book1/31chap26#chap26">Chapter VII - Betrayal</a></p>
<p class="toc-text"><a href="#/Book1/32chap27#chap27">Chapter VIII - Journey to Darkness</a></p>
<p class="toc-text"><a href="#/Book1/33chap28#chap28">Book Four The Road From Concord Bridge</a></p>
<p class="toc-text"><a href="#/Book1/34chap29#chap29">Chapter I - The Letter</a></p>
<p class="toc-text"><a href="#/Book1/35chap30#chap30">Chapter II - A Death in Philadelphia</a></p>
<p class="toc-text"><a href="#/Book1/36chap31#chap31">Chapter III - Alicia</a></p>
<p class="toc-text"><a href="#/Book1/37chap32#chap32">Chapter IV - Too Much for the Whistle</a></p>
<p class="toc-text"><a href="#/Book1/38chap33#chap33">Chapter V - Alarm at Midnight</a></p>
<p class="toc-text"><a href="#/Book1/39chap34#chap34">Chapter VI - “God Damn It, They Are Firing Ball!”</a></p>
<p class="toc-text"><a href="#/Book1/40chap35#chap35">Afterword</a></p>
<p class="toc-text-A1"><a href="#/Book2/1cover">The Rebels</a></p>
<p class="toc-text"><a href="#/Book2/6start#chap1">Book One <i>Our Lives, Our Fortunes and Our Sacred Honor</i></a></p>
<p class="toc-text"><a href="#/Book2/7chap2#chap2">Chapter I. A Taste of Steel</a></p>
<p class="toc-text"><a href="#/Book2/8chap3#chap3">Chapter II. Sermon Hill</a></p>
<p class="toc-text"><a href="#/Book2/9chap4#chap4">Chapter III. Birth</a></p>
<p class="toc-text"><a href="#/Book2/10chap5#chap5">Chapter IV. The Uprising</a></p>
<p class="toc-text"><a href="#/Book2/11chap6#chap6">Chapter V. The Guns of Winter</a></p>
<p class="toc-text"><a href="#/Book2/12chap7#chap7">Chapter VI “The Seedtime of Continental Union”</a></p>
<p class="toc-text"><a href="#/Book2/13chap8#chap8">Chapter VII. The Thirteen Clocks</a></p>
<p class="toc-text"><a href="#/Book2/14chap9#chap9">Book Two <i>The Times That Try Men’s Souls</i></a></p>
<p class="toc-text"><a href="#/Book2/15chap10#chap10">Chapter I. The Privateers</a></p>
<p class="toc-text"><a href="#/Book2/16chap11#chap11">Chapter II. Deed of Darkness</a></p>
<p class="toc-text"><a href="#/Book2/17chap12#chap12">Chapter III. Reunion in Pennsylvania</a></p>
<p class="toc-text"><a href="#/Book2/18chap13#chap13">Chapter IV. Retreat at Brandywine</a></p>
<p class="toc-text"><a href="#/Book2/19chap14#chap14">Chapter V “I Mean to March to Hostile Ground”</a></p>
<p class="toc-text"><a href="#/Book2/20chap15#chap15">Chapter VI. The Drillmaster</a></p>
<p class="toc-text"><a href="#/Book2/21chap16#chap16">Chapter VII. Rackham</a></p>
<p class="toc-text"><a href="#/Book2/22chap17#chap17">Book Three <i>Death and Resurrection</i></a></p>
<p class="toc-text"><a href="#/Book2/23chap18#chap18">Chapter I. The Wolves</a></p>
<p class="toc-text"><a href="#/Book2/24chap19#chap19">Chapter II. The Guns of Summer</a></p>
<p class="toc-text"><a href="#/Book2/25chap20#chap20">Chapter III. The Shawnee Spy</a></p>
<p class="toc-text"><a href="#/Book2/26chap21#chap21">Chapter IV. The Price of Heaven</a></p>
<p class="toc-text"><a href="#/Book2/27chap22#chap22">Chapter V. The Woman From Virginia</a></p>
<p class="toc-text"><a href="#/Book2/28chap23#chap23">Epilogue The World Turned Upside Down</a></p>
<p class="toc-text"><a href="#/Book2/29chap24#chap24">Afterword</a></p>
<p class="toc-text-A1"><a href="#/Book3/1cover">The Seekers</a></p>
<p class="toc-text"><a href="#/Book3/5start#chap1">Introduction:<br/>The Author as (Bad?) Actor</a></p>
<p class="toc-text"><a href="#/Book3/7chap2#chap2">The Kent Family</a></p>
<p class="toc-text"><a href="#/Book3/8chap3#chap3">Book One: Kent and Son</a></p>
<p class="toc-text"><a href="#/Book3/9chap4#chap4">Chapter I Battle Morning</a></p>
<p class="toc-text"><a href="#/Book3/10chap5#chap5">Chapter II The Charge</a></p>
<p class="toc-text"><a href="#/Book3/11chap6#chap6">Chapter III Clouds at Homecoming</a></p>
<p class="toc-text"><a href="#/Book3/12chap7#chap7">Chapter IV The Storm Breaks</a></p>
<p class="toc-text"><a href="#/Book3/13chap8#chap8">Chapter V “Scenes of Life Among the Mighty”</a></p>
<p class="toc-text"><a href="#/Book3/14chap9#chap9">Chapter VI Wedding Night</a></p>
<p class="toc-text"><a href="#/Book3/15chap10#chap10">Chapter VII Wagon Road</a></p>
<p class="toc-text"><a href="#/Book3/16chap11#chap11">Chapter VIII Ark to the Wilderness</a></p>
<p class="toc-text"><a href="#/Book3/17chap12#chap12">Book Two: The Enemy Land</a></p>
<p class="toc-text"><a href="#/Book3/18chap13#chap13">Chapter I The Cabin</a></p>
<p class="toc-text"><a href="#/Book3/19chap14#chap14">Chapter II Old Ghosts and New Beginnings</a></p>
<p class="toc-text"><a href="#/Book3/20chap15#chap15">Chapter III The Burning</a></p>
<p class="toc-text"><a href="#/Book3/21chap16#chap16">Chapter IV Problems of a Modernist</a></p>
<p class="toc-text"><a href="#/Book3/22chap17#chap17">Chapter V The Mark</a></p>
<p class="toc-text"><a href="#/Book3/23chap18#chap18">Chapter VI Blood</a></p>
<p class="toc-text"><a href="#/Book3/24chap19#chap19">Book Three: Voices of War</a></p>
<p class="toc-text"><a href="#/Book3/25chap20#chap20">Chapter I Jared</a></p>
<p class="toc-text"><a href="#/Book3/26chap21#chap21">Chapter II A Mackerel by Moonlight</a></p>
<p class="toc-text"><a href="#/Book3/27chap22#chap22">Chapter III The Frigate</a></p>
<p class="toc-text"><a href="#/Book3/28chap23#chap23">Chapter IV The Devil’s Companion</a></p>
<p class="toc-text"><a href="#/Book3/29chap24#chap24">Chapter V “Her Sides Are Made of Iron!”</a></p>
<p class="toc-text"><a href="#/Book3/30chap25#chap25">Chapter VI Heritage</a></p>
<p class="toc-text"><a href="#/Book3/31chap26#chap26">Book Four: Cards of Fate</a></p>
<p class="toc-text"><a href="#/Book3/32chap27#chap27">Chapter I Mr. Piggott</a></p>
<p class="toc-text"><a href="#/Book3/33chap28#chap28">Chapter II Act of Vengeance</a></p>
<p class="toc-text"><a href="#/Book3/34chap29#chap29">Chapter III Act of Murder</a></p>
<p class="toc-text"><a href="#/Book3/35chap30#chap30">Chapter IV Ordeal</a></p>
<p class="toc-text"><a href="#/Book3/36chap31#chap31">Chapter V Reverend Blackthorn</a></p>
<p class="toc-text"><a href="#/Book3/37chap32#chap32">Chapter VI Judge Jackson</a></p>
<p class="toc-text"><a href="#/Book3/38chap33#chap33">Chapter VII Pursuit to St. Louis</a></p>
<p class="toc-text"><a href="#/Book3/39chap34#chap34">Chapter VIII The Windigo</a></p>
<p class="toc-text"><a href="#/Book3/40chap35#chap35">Chapter IX “I Will Seek That Which Was Lost”</a></p>
<p class="toc-text"><a href="#/Book3/41chap36#chap36">Epilogue In the Tepee of the Dog Soldier</a></p>
<p class="toc-text"><span href="#/Book3/teaser00" title="Link target outside of Sample">Preview: <i>The Furies</i></span></p>
<p class="toc-text"><a href="#/Book3/42abouttheauthor#biography">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?197ab8c3